import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.isMmcAdmin = false;
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.resultList = [];

		state.eqipDtlCdList = []; //장비상세 selectBox
		state.eqipKndCdList = []; //장비종류 selectBox
		state.calInstCdList = []; //교정업체 selectBox
		state.calStCdList = []; //교정상태 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.calWayCdList = []; //교정방식 selectBox
		state.calCyclCdList = []; //교정주기 selectBox
		state.calRsltCdList = []; //교정결과 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.ynCdList = []; //보고서유무 selectBox
		state.sndStCdList = []; //메일 발송상태 selectBox

		state.pvoResultList = [];
		state.pvoPagingInfo = PAGING_INFO();

		state.csetResultList = [];
		state.csetPagingInfo = PAGING_INFO();

		state.pvoResultList = [];
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value, gubun }) => {
		if (!gubun) {
			state.pagingInfo[key] = value;
		} else {
			state[gubun][key] = value;
		}
	}
};
